import { FunctionComponent } from "react";
import styles from "./RightPanel.module.css";
import { TColumnName, TDataset } from "../../types";
import Table, { TableCell } from "../../components/Table";
import withErrorBoundary from "../../hocs/withErrorBoundary";
import ColumnNameUtils from "../../utils/ColumnNameUtils";
import Typography from "../../components/Typography";

type TProps = {
  clickedPoint?: TDataset[0];
};

const PointDetails: FunctionComponent<TProps> = (props) => (
  <>
    {props.clickedPoint ? (
      <Table>
        <tbody>
          {Object.entries(props.clickedPoint)
            .filter(
              ([key]) => !ColumnNameUtils.isMetaColumn(key as TColumnName)
            )
            .sort()
            .map(([key, value]) => (
              <tr key={key}>
                <TableCell type="key">
                  {Boolean(key) ? (
                    key
                  ) : (
                    <span className={styles.missing}>(missing)</span>
                  )}
                </TableCell>

                <TableCell type="value">{value}</TableCell>
              </tr>
            ))}
        </tbody>
      </Table>
    ) : (
      <Typography variant="body">
        Click on a data point to inspect it
      </Typography>
    )}
  </>
);

export default withErrorBoundary(PointDetails);
